import React from "react";
import Card from "../../UI/Card";

const WhyChoose = ({ data }) => {
  return (
    <div className="w-[90%] mx-auto mt-16">
      <h3 className="text-btnColor font-popinsBold text-3xl md:text-4xl lg:text-6xl pt-3 text-center w-[95%] lg:w-[80%] mx-auto">
        {data.heading}
      </h3>
      <div className="bg-themeColor rounded-2xl px-6 py-8 lg:py-9 mt-10">
        <Card data={data.feature} />
      </div>
    </div>
  );
};

export default WhyChoose;
